import React, {FC} from 'react';
import styled from 'styled-components';

import {CardModel} from '../../../../models/api/cardModel';
import {VisualContactModel} from '../../../../models/api/visualContactModel';
import {ContactCardPanelId} from '../../../../store/panels/panelStateBase';
import {ContactCardFooterAddToContactsActionContainer} from './contactCardFooterAddToContactsActionContainer';
import {ContactCardFooterComposeMessageActionContainer} from './contactCardFooterComposeMessageActionContainer';
import {ContactCardFooterNewEventContainer} from './contactCardFooterNewEventContainer';
import {ContactCardFooterSearchHistoryContainer} from './contactCardFooterSearchHistoryContainer';

/*
 * Props.
 */

interface ContactCardFooterActionsProps {
  panelId: ContactCardPanelId;
  card?: CardModel;
  visualContact: VisualContactModel;
}

/*
 * Style.
 */

const StyledActionsWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 4px;
`;

/*
 * Component.
 */

export const ContactCardFooterActions: FC<ContactCardFooterActionsProps> = (props) => {
  const {panelId, card, visualContact} = props;

  return (
    <StyledActionsWrapperDiv>
      <ContactCardFooterAddToContactsActionContainer
        panelId={panelId}
        card={card}
        visualContact={visualContact}
      />
      <ContactCardFooterComposeMessageActionContainer card={card} visualContact={visualContact} />
      <ContactCardFooterNewEventContainer panelId={panelId} visualContact={visualContact} />
      <ContactCardFooterSearchHistoryContainer panelId={panelId} visualContact={visualContact} />
    </StyledActionsWrapperDiv>
  );
};
